import { Table, AutoSizer, InfiniteLoader, Column } from "react-virtualized";
import React from "react";
import CustomColumn from "./CustomColumn";
import isEqual from "lodash/isEqual";
import Axios from "axios";

export default class InfiniteScrollTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      items: [],
      totalItemsLength: 0,
      loadedItems: 0,
      dataModified: false,
      index: undefined,
      deleted_status: false,
    };
    this.loadMore = this.loadMore.bind(this);
  }

  static getDerivedStateFromProps(props, state) {
    if (!isEqual(props.data, state.data)) {
      const { data, searchAttributes, lastKey, input } = props;
      const len = data.length;
      let items = props.data.slice(0, 10);
      let body = {
        ...lastKey,
        ...searchAttributes,
        ...input,
        count: 50,
      };
      return {
        data: [...data],
        totalItemsLength: len,
        items,
        loadedItems: items.length,
        searchCriteria: body,
      };
    }
    if (props.deleted_status !== state.deleted_status) {
      return { deleted_status: props.deleted_status };
    }
    return null;
  }

  loadMore() {
    let newItems = this.state.items;
    let startIndex = newItems.length;

    this.setState({ items: newItems }); //, searchCriteria: body });
    const promise = new Promise((resolve, reject) => {
      this.promiseResolve = resolve;
    });
    if (this.state.searchCriteria.lastEvaluatedKey)
      this.actuallyLoadMore(startIndex);
    return promise;
  }

  actuallyLoadMore(startIndex) {
    let { items, loadedItems, searchCriteria, asc } = this.state;
    const { authToken, url, searchAttributes } = this.props;

    Axios.defaults.headers.common["Authorization"] = authToken;
    Axios.defaults.headers.common["Pragma"] = "no-cache";

    Axios.post(url, searchCriteria)
      .then((res) => {
        let counter = startIndex;
        let response =
          res.data && res.data.Items ? res.data.Items : res.data.Users;

        response.forEach(function (user) {
          let Attributes = {};
          user.Attributes.forEach((attr) => {
            Attributes[attr.Name] = attr.Value;
          });
          items[counter++] = {
            email: Attributes.email,
            ...user,
            ...Attributes,
          };
        });
        loadedItems += res.data.Users.length;
        let body = {
          lastEvaluatedKey: res.data.PaginationToken,
          sort_order: asc && "asc",
          ...searchAttributes,
        };

        this.setState(
          { items, loadedItems, index: undefined, searchCriteria: body },
          () => {
            // resolve the promise after data where fetched
            this.promiseResolve();
          }
        );
      })
      .catch((err) => {
        console.log("ERROR--->", err);
        this.props.errorWhileFetch("400_SYSTEM_ERROR");
      });
  }

  getColumns(data = []) {
    return data.map((col, index) => {
      const { customCell = null } = col;
      return (
        <Column
          {...col}
          key={index}
          dataKey={col.dataKey}
          width={col.width ? col.width : 200}
          height={100}
          label={col.label}
          headerRenderer={(data) => {
            return (
              <>
                <CustomColumn
                  {...this.props}
                  key={index}
                  col={col}
                  index={index}
                  colData={data}
                  getDataOnSort={this.getDataOnSort}
                />
              </>
            );
          }}
          cellRenderer={(data) => {
            return customCell ? customCell(data) : data.cellData;
          }}
        />
      );
    });
  }
  render() {
    const { columnData } = this.props;
    const columns = this.getColumns(columnData);
    const {
      rowHeight = 40,
      headerHeight = 100,
      rowClassName = "",
      gridClassName = "",
    } = this.props;
    return (
      <div className="infiniteScrollContainer">
        <InfiniteLoader
          isRowLoaded={({ index }) => !!this.state.items[index]}
          loadMoreRows={this.loadMore}
          rowCount={1000000}
        >
          {({ onRowsRendered, registerChild }) => (
            <AutoSizer>
              {({ width, height }) => (
                <div>
                  <Table
                    ref={registerChild}
                    onRowsRendered={onRowsRendered}
                    rowClassName={rowClassName}
                    headerHeight={headerHeight}
                    width={width}
                    height={height}
                    rowHeight={rowHeight}
                    gridClassName={gridClassName}
                    rowCount={this.state.items.length}
                    rowGetter={({ index }) => this.state.items[index]}
                    scrollToIndex={this.state.index}
                    gridStyle={{ zIndex: "0 !important" }}
                  >
                    {columns}
                  </Table>
                </div>
              )}
            </AutoSizer>
          )}
        </InfiniteLoader>
      </div>
    );
  }
}
